export default __webpack_public_path__ + "static/media/loading-telia-logo.0a96d3b9.gif";